module.exports = __webpack_public_path__ + "static/media/Step4.40a653a6.png";